import React from "react";
// import { connect } from "react-redux";

import { Spinner } from "reactstrap";

class DataContainer extends React.Component {
  state = {
    dataArray: this.props.initialStaticData || [],
    loading: true,
    page: 0,
    nextPage: 0,
    prevY: 0,
    lastVisible: "",
    limit: 10,
    active_id: "",
    moreDataAvailable: true,
    searchKeyword: ""
  };

  componentDidUpdate(prevProps, prevState) {
    const { categorizedData, searchQuery } = this.props;
    console.log({ data: this.state.dataArray });
    this.setState({
      loading: true,
      dataArray: [],
      lastVisible: "",
      moreDataAvailable: true,
      page: 0,
      searchKeyword: ""
    });
    this.props
      .callInitialData({ limit: this.state.limit })
      .then(data => {
        this.setRenderableData(data);
      })
      .catch(error => {
        console.log(error);
        this.setState({
          loading: false,
          error
        });
      });

    // Working of infinite Scroll
    var options = {
      root: null,
      rootMargin: "0px",
      threshold: 1.0
    };

    // It observes the referenced element
    this.observer = new IntersectionObserver(
      this.handleObserver.bind(this),
      options
    );
    this.observer.observe(this.loadingRef);
    // }
  }

  componentDidMount() {
    if (!this.props.initialStaticData) {
      // console.log({ props: this.props });
      this.props
        .callInitialData({ limit: this.state.limit })
        .then(data => {
          this.setRenderableData(data);
        })
        .catch(error => {
          console.log(error);
          this.setState({
            loading: false,
            error
          });
        });
    }

    // Working of infinite Scroll
    var options = {
      root: null,
      rootMargin: "0px",
      threshold: 1.0
    };

    // It observes the referenced element
    this.observer = new IntersectionObserver(
      this.handleObserver.bind(this),
      options
    );
    this.observer.observe(this.loadingRef);
  }

  // Handling On observe scroll
  handleObserver(entities, observer) {
    const y = entities[0].boundingClientRect.y;
    // It runs when there is more data in db
    if (this.state.moreDataAvailable) {
      // When the window comes to the referenced element
      if (this.state.prevY > y) {
        console.log("if k andar", this.state.prevY);
        this.setState({ loading: true });

        // console.log({ search: this.state.searchKeyword });
        this.props
          .loadMoreData({
            limit: this.state.limit,
            startAfter: this.state.lastVisible
          })
          .then(jobs => {
            this.setRenderableData(jobs);
          })
          .catch(error => {
            console.log(error);
            this.setState({
              loading: false,
              error
            });
          });

        // this.setState({ page: this.state.page + 1 });
      }
    }
    this.setState({ prevY: y });
  }

  render() {
    const dataArray = this.state.dataArray;
    // console.log({ dataArray });

    const loadingCSS = {
      height: "50px",
      margin: "50px",
      display: "flex",
      justifyContent: "center",
      alignItems: "center"
    };

    const loadingTextCSS = {
      display: this.state.loading ? "block" : "none"
    };

    return (
      <React.Fragment>
        <div className="featured-jobs-container">
          {dataArray.length > 0 ? (
            <div>
              <h2>Hello World!</h2>
            </div>
          ) : (
            !this.state.loading && (
              <h4 style={{ textAlign: "center" }}>Jobs not Found.</h4>
            )
          )}

          {/* Loading infinite */}
          <div
            ref={loadingRef => (this.loadingRef = loadingRef)}
            style={loadingCSS}
          >
            <span style={loadingTextCSS}>
              <Spinner size="small" />
            </span>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

export default DataContainer;
